import { OrgUser, RoleInfo, User } from 'src/types';

export const toDateString = (timestamp: number): string => {
  const date = new Date(timestamp);
  const day = date.getDate();
  const ords = [null, 'st', 'nd', 'rd'];
  const ordinal = day > 10 && day < 14 ? 'th' : ords[day % 10] || 'th';

  const month = date.toLocaleString('en-GB', { month: 'long' });
  const year = date.getFullYear();

  return `${day}${ordinal} ${month} ${year}`;
};

export const getInitials = (firstName = '', lastName = ''): string => {
  const lastNames = lastName.split(' ');
  return (
    firstName.charAt(0).toUpperCase() +
    lastNames[lastNames.length - 1].charAt(0).toUpperCase()
  );
};

export const capitalizeWord = (word: string): string =>
  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

export const getUserName = ({
  firstName,
  lastName,
  email,
}: OrgUser): string => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  if (email) {
    return email;
  }
  return 'user';
};

const mapRoleNames = (
  roles: OrgUser['roles'],
  availableRoles: RoleInfo[]
): OrgUser['roles'] => {
  return roles.reduce((roleList: OrgUser['roles'], role: string) => {
    const roleDefinition = availableRoles.find(
      (roleInfo: RoleInfo) => roleInfo.name === role
    );
    if (roleDefinition) {
      return [...roleList, roleDefinition.alias];
    }
    return roleList;
  }, []);
};

const sortRolesAsc = (roles: OrgUser['roles']) => {
  return roles.sort((a, b) => (a.toUpperCase() < b.toUpperCase() ? -1 : 1));
};

export const transformRoles = (
  roles: OrgUser['roles'],
  availableRoles: RoleInfo[]
): string => {
  const mappedRoles = mapRoleNames(roles || [], availableRoles);
  if (!mappedRoles || !mappedRoles.length) {
    return '-';
  }
  const sortedRoles = sortRolesAsc(mappedRoles);
  return sortedRoles.join(', ').trim();
};

export const getFlatOrgsLength = (orgs: User['organisations']): number => {
  if (!orgs || orgs.length === 0) return 0;
  return orgs.reduce(
    (total, org) =>
      total + (org.childOnly ? 0 : 1) + (org.childIds?.length || 0),
    0
  );
};
